import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {ref} from 'vue'
import {useGlobalSetting} from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimepickerSmall',
  props: /*@__PURE__*/_mergeModels({
  label: {
    type: String,
    default: "Zeit"
  },
  variant: {
    type: String,
    default: "outlined"
  },
  readonly: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const menuOpen = ref(false)

const model = _useModel(__props, "modelValue")

const localProps = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: menuOpen.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuOpen).value = $event)),
    "close-on-content-click": false
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_text_field, _mergeProps({
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        class: localProps.readonly ? 'custom-readonly' : '',
        label: localProps.label,
        rules: [localProps.required ? v => !!v || 'Bitte Zeit wählen!' : () => true],
        variant: _unref(useGlobalSetting)().globalTextVariant,
        readonly: "",
        disabled: localProps.disabled
      }, props), null, 16, ["modelValue", "class", "label", "rules", "variant", "disabled"])
    ]),
    default: _withCtx(() => [
      (!localProps.readonly)
        ? (_openBlock(), _createBlock(_component_v_time_picker, {
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
            format: "24hr"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})